(function (Drupal) {
  Drupal.behaviors.mobileMenuAccordion = {
    attach(context) {
      const toggles = context.querySelectorAll(".mobile-submenu-toggle");

      toggles.forEach((toggle) => {
        toggle.addEventListener("click", () => {
          toggles.forEach((other) => {
            if (other !== toggle) {
              const target = document.querySelector(
                other.getAttribute("data-bs-target")
              );
              if (target?.classList.contains("show")) {
                bootstrap.Collapse.getInstance(target)?.hide();
              }
            }
          });
        });
      });
    },
  };

  document.querySelectorAll(".mobile-submenu-toggle").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
    });
  });
})(Drupal);
